import React from 'react'

export type HeaderUser = {
  id: number
  amountCredit: { cents: number; formatted: string }
  managerOfClientCompany?: { name: string; dashboardUrl: string } | null
}

export type HeaderContextValues = {
  truckDashboardHeaderUrl: (url: string) => string
  logoUrl: string
  cartItems: number
  user: HeaderUser | null
}

export const HeaderContext = React.createContext<HeaderContextValues>({
  truckDashboardHeaderUrl: () => '',
  logoUrl: '',
  cartItems: 0,
  user: null
})
